import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment as env } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ApiRequestParameters } from 'src/app/auth/interface/table.params.interface';
import { Survey } from '../interfaces/survey.interface';

@Injectable({
  providedIn: 'root',
})
export class SurveyService {
  private readonly baseUrl: string = env.apiUrl;

  constructor(private http: HttpClient) {}

  getSurveys(
    params: ApiRequestParameters
  ): Observable<{ surveys: Survey[]; totalRecords: number }> {
    let queryParams = new HttpParams()
      .set('skip', params.skip.toString())
      .set('limit', params.limit.toString())
      .set('sortField', params.sortField)
      .set('sortOrder', params.sortOrder.toString())
      .set('globalFilter', params.globalFilter);

    return this.http.get<{ surveys: any[]; totalRecords: number }>(
      `${this.baseUrl}/surveys`,
      {
        params: queryParams,
      }
    );
  }
  getSurveysByUser(
    params: ApiRequestParameters,
    id: number
  ): Observable<{ surveys: Survey[]; totalRecords: number }> {
    let queryParams = new HttpParams()
      .set('skip', params.skip.toString())
      .set('limit', params.limit.toString())
      .set('sortField', params.sortField)
      .set('sortOrder', params.sortOrder.toString())
      .set('globalFilter', params.globalFilter);

    return this.http.get<{ surveys: any[]; totalRecords: number }>(
      `${this.baseUrl}/surveys/user/${id}`,
      {
        params: queryParams,
      }
    );
  }
  getHistorySurveys(params: ApiRequestParameters, id: number): Observable<any> {
    let queryParams = new HttpParams()
      .set('skip', params.skip.toString())
      .set('limit', params.limit.toString())
      .set('sortField', params.sortField)
      .set('sortOrder', params.sortOrder.toString())
      .set('globalFilter', params.globalFilter);

    return this.http.get<any>(`${this.baseUrl}/surveys-history/history/${id}`, {
      params: queryParams,
    });
  }
  getAllEmails(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/users/emails`);
  }

  editSurveyInformation(id: number, survey: any): Observable<Survey> {
    return this.http.patch<Survey>(`${this.baseUrl}/surveys/${id}`, survey);
  }

  getSurveyQuestions(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/survey-questions`);
  }

  updateQuestion(id: number, data: any): Observable<any> {
    return this.http.patch<Survey>(
      `${this.baseUrl}/survey-questions/${id}`,
      data
    );
  }

  sendSurveyToEmail(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/node-mailer/survey-resume/`,
      data
    );
  }
  saveToRecipientHistory(data: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/survey-recipients-history/`,
      data
    );
  }
  getSurveyByID(id: number): Observable<{ surveys: Survey[] }> {
    return this.http.get<{ surveys: any[] }>(
      `${this.baseUrl}/surveys/id/${id}`
    );
  }
  getSurveyBySessionId(id: number): Observable<{ surveys: Survey[] }> {
    return this.http.get<{ surveys: any[] }>(
      `${this.baseUrl}/surveys/session-id/${id}`
    );
  }
}
